import request, { DELETE } from '../../utils/request';

export default requestRecordId => request(`/request-records/${requestRecordId}`, { method: DELETE });
